import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

interface UseGetLineItemProps {
  lineItemId: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getMonthDistributionByLineItemId = async (
  lineItemId: string,
  budgetId: string
) =>
  await axiosAuth.get(
    `${BUDGET_LINE_ITEMS(budgetId)}/${lineItemId}/monthly-distribution`
  );

const useGetMonthDistributionByLineItemId = ({
  queryParams,
  budgetId,
  lineItemId,
}: UseGetLineItemProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["monthly-distribution", budgetId, lineItemId],
    queryFn: () => getMonthDistributionByLineItemId(lineItemId, budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!budgetId && !!lineItemId && (queryParams?.enabled ?? true),
  });
};

export default useGetMonthDistributionByLineItemId;
